import{create as o}from"../../nano-css/index.js";import{addon as s}from"../../nano-css/addon/cssom.js";import{addon as n}from"../../nano-css/addon/vcssom.js";import"react";var a=o();s(a),n(a);
//# sourceMappingURL=useCss.js.map
